<template>
  <div>
    <message type="warning" class="q-mb-md">
      Client details <strong>cannot be changed</strong> after they have been added. <br />
      Please ensure the details below are correct before proceeding.
    </message>
    <q-list bordered class="radius">
      <q-item>
        <q-item-section>Name</q-item-section>
        <q-item-section class="text-subtitle2" avatar>
          {{ lastName }}, {{ firstName }}
        </q-item-section>
      </q-item>
      <q-item>
        <q-item-section>Email</q-item-section>
        <q-item-section class="text-subtitle2" avatar>
          {{ email }}
        </q-item-section>
      </q-item>
       <q-item>
        <q-item-section>Phone Number</q-item-section>
        <q-item-section class="text-subtitle2" avatar>
          {{ phone }}
        </q-item-section>
      </q-item>
      <q-item>
        <q-item-section>Date of Birth</q-item-section>
        <q-item-section class="text-subtitle2" avatar>
          {{ $filters.date(dateOfBirth) }}
        </q-item-section>
      </q-item>
      <q-separator />
      <q-item v-if="fileRefNo">
        <q-item-section>File Reference Number</q-item-section>
        <q-item-section class="text-subtitle2" avatar>
          {{ fileRefNo }}
        </q-item-section>
      </q-item>
      <q-item>
        <q-item-section>Date of Loss</q-item-section>
        <q-item-section class="text-subtitle2" avatar>
          {{ $filters.date(dateOfLoss) }}
        </q-item-section>
      </q-item>
    </q-list>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Message from '@/components/message/Message.vue';

export default defineComponent({
  components: { Message },
  props: {
    firstName: {
      type: String,
      required: true,
    },
    lastName: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      required: true,
    },
    dateOfBirth: {
      type: String,
      required: true,
    },
    dateOfLoss: {
      type: String,
      required: true,
    },
    fileRefNo: String,
  },
});
</script>
